import { defineMessages } from 'react-intl-next';

export default defineMessages({
	spotlightTitle: {
		id: 'jira.nin.saved.filters.menu.spotlight.title',
		defaultMessage: 'Finding and creating saved filters just got easier',
		description:
			'Title for the onboarding spotlight of the new saved filters menu in List (All work) view.',
	},
	spotlightBody: {
		id: 'jira.nin.saved.filters.menu.spotlight.body',
		defaultMessage: "Find filters you've saved, and save new ones in one place.",
		description:
			'Body for the onboarding spotlight of the new saved filters menu in List (All work) view.',
	},
	spotlightDismissButton: {
		id: 'jira.nin.saved.filters.menu.spotlight.dismiss',
		defaultMessage: 'OK',
		description: 'Label for dismiss button to close the spotlight.',
	},
});
